export default __webpack_public_path__ + "static/lozenge-icon-do-light-b0674042e793b568f77eaaa53abac2a73d8a02ca45b404f24d0c0e35280ec458.png";